import { forwardRef } from 'react'
import {
  Link as RouterLink,
  NavLink as RouterNavLink,
  type LinkProps,
  type NavLinkProps,
  type To,
} from 'react-router-dom'
import { useLocalizedPath } from '@/hooks/useLocalizedPath'

/**
 * `react-router-dom` `Link` / `NavLink` with the current language prefixed to
 * internal targets, so call sites keep writing `to="/cart"`.
 */

function useLocalizedTo(to: To): To {
  const lp = useLocalizedPath()
  if (typeof to === 'string') return lp(to)
  return to.pathname ? { ...to, pathname: lp(to.pathname) } : to
}

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(function Link({ to, ...props }, ref) {
  return <RouterLink ref={ref} to={useLocalizedTo(to)} {...props} />
})

export const NavLink = forwardRef<HTMLAnchorElement, NavLinkProps>(function NavLink({ to, ...props }, ref) {
  return <RouterNavLink ref={ref} to={useLocalizedTo(to)} {...props} />
})
